import { CHINA_PROVINCE } from '@meiqia/constants/lib/province';

const isChinaProvince = (province: string) => CHINA_PROVINCE.includes(province);

export { isChinaProvince };
